<template>
  <div class="caratula wrapper-content w-100">
    <h1>{{title}}</h1>
    <div>
      <LmComponentLoading v-if="isLoading" fixed />
      <LmBreadcrumb v-if="showBreadcrumb" />
      <div id="printContainer">
        <div class="caratula-cuerpo">
          <img :src="collapsedLogoImg" alt="" height="46" class="float-left mr-2 logoImg">
          <h1 class="text-center">{{itemDetail.expediente}}</h1>
          <h4 v-if="itemDetail.tipo_iniciador==='AREA'">INICIADOR: {{itemDetail.nombre_area_interna}}</h4>
          <h4 v-else>INICIADOR: {{itemDetail.iniciador}} {{itemDetail.otros}}</h4>
          <h4>FECHA INICIO: {{itemDetail.fecha_inicio | lmFormatDateFilter}}</h4>
          <h5 v-if="itemDetail.numero_nota_interna">NÚMERO NOTA INTERNA: {{itemDetail.numero_nota_interna}}</h5>
          <h5>CLASIFICACION: {{itemDetail.clasificacion}}</h5>
          <h5 v-if="itemDetail.subclasificaciones">SUBCLASIFICACIONES: {{itemDetail.subclasificaciones}}</h5>
          <h5 v-if="itemDetail.observaciones">DETALLE: {{itemDetail.observaciones}}</h5>
          <h5 v-if="itemDetail.numero_cuenta">NRO CUENTA: {{itemDetail.numero_cuenta}}</h5>
          <h5 v-else-if="itemDetail.numero_padron">NRO PADRÓN: {{itemDetail.numero_padron}}</h5>
          <h5 v-if="itemDetail.principal">PRINCIPAL: {{itemDetail.principal}}</h5>
          <h5 v-if="itemDetail.direccion_tramite">DIRECCIÓN DEL TRÁMITE: {{itemDetail.direccion_tramite}}</h5>
        </div>
        <div class="troquel row">
          <div class="columna col-6">
            <img :src="collapsedLogoImg" alt="" height="24" class="float-left mr-2 logoImg"><h5>MUNICIPALIDAD DE VTE. LOPEZ</h5>
            <h6>{{itemDetail.expediente}}</h6>
            <div class="cuerpo-troquel">
              <div v-if="itemDetail.tipo_iniciador==='AREA'">INICIADOR: {{itemDetail.nombre_area_interna}}</div>
              <div v-else>INICIADOR: {{itemDetail.iniciador}} {{itemDetail.otros}}</div>
              <div class="clasificaciones">CLASIF: {{itemDetail.clasificacion}}</div>
              <div v-if="itemDetail.subclasificaciones">SUBCLAS: {{itemDetail.subclasificaciones}}</div>
              <div v-if="itemDetail.observaciones">DETALLE: {{itemDetail.observaciones}}</div>
              <div>F INICIO: {{itemDetail.fecha_inicio | lmFormatDateFilter}}</div>
              <div v-if="itemDetail.numero_cuenta">CUENTA: {{itemDetail.numero_cuenta}}</div>
              <div v-else-if="itemDetail.numero_padron">PADRÓN: {{itemDetail.numero_padron}}</div>
              <div v-if="itemDetail.principal">PRINCIPAL: {{itemDetail.principal}}</div>
              <div v-if="itemDetail.direccion_tramite">DIRECCIÓN DEL TRÁMITE: {{itemDetail.direccion_tramite}}</div>
            </div>
          </div>
          <div class="columna col-6">
            <img :src="collapsedLogoImg" alt="" height="24" class="float-left mr-2 logoImg"><h5>MUNICIPALIDAD DE VTE. LOPEZ</h5>
            <h6>{{itemDetail.expediente}}</h6>
            <div class="cuerpo-troquel">
              <div v-if="itemDetail.tipo_iniciador==='AREA'">INICIADOR: {{itemDetail.nombre_area_interna}}</div>
              <div v-else>INICIADOR: {{itemDetail.iniciador}} {{itemDetail.otros}}</div>
              <div class="clasificaciones">CLASIF: {{itemDetail.clasificacion}}</div>
              <div v-if="itemDetail.subclasificaciones">SUBCLAS: {{itemDetail.subclasificaciones}}</div>
              <div v-if="itemDetail.observaciones">DETALLE: {{itemDetail.observaciones}}</div>
              <div>F INICIO: {{itemDetail.fecha_inicio | lmFormatDateFilter}}</div>
              <div v-if="itemDetail.numero_cuenta">CUENTA: {{itemDetail.numero_cuenta}}</div>
              <div v-else-if="itemDetail.numero_padron">PADRÓN: {{itemDetail.numero_padron}}</div>
              <div v-if="itemDetail.principal">PRINCIPAL: {{itemDetail.principal}}</div>
              <div v-if="itemDetail.direccion_tramite">DIRECCIÓN DEL TRÁMITE: {{itemDetail.direccion_tramite}}</div>
            </div>
          </div>
        </div>
      </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          v-if="showPDFButton"
          type="button"
          @click.native="print()"
          :value="$t('print')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {},
      formIsProcessing: false,
      isLoading: true
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail']),
    ...mapState('settings', ['collapsedLogoImg']),
    apiCall () {
      return {
        path: this.newOrEditEndpointUri,
        id: this.isOnEditMode ? this.$route.params.id : null
      }
    }
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    downloadCsvFileName: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      default: true
    },
    showPDFButton: {
      type: Boolean,
      required: false,
      default: false
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    goBackRoute: {
      type: String,
      required: false
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('commons', ['deleteItem', 'getItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    ...mapActions('session', ['getUserInfo']),
    goBackBtn () {
      this.$router.go(-1)
    },
    print () {
      const prevTitle = document.title
      document.title = `caratula-${this.itemDetail.expediente}`
      this.$htmlToPaper('printContainer')
      document.title = prevTitle
    }
  },
  created () {
    (async () => {
      await this.getItemDetail(this.apiCall)
        .catch(error => {
          console.log(error)
          this.$router.replace({ name: '404' })
        })
      this.isLoading = false
    })()
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  form
    padding-top: 50px
  #printContainer
    h4
      margin-bottom: 30px
    h6
      margin-left: 20px
    .troquel
      margin-top: 240px
      .clasificaciones
        margin-top: 30px
</style>
